import React from 'react'
import { Box } from '@mui/material'

interface FlipContainerProps {
  frontView: JSX.Element
  backView: JSX.Element
  isFlipped: boolean
  button: JSX.Element
}

// VisibilityIcon default

export const FlipContainer: React.FC<FlipContainerProps> = ({
  isFlipped,
  frontView,
  backView,
  button
}) => {
  return (
    <Box
      style={{
        transform: isFlipped ? 'rotateY(180deg)' : 'none'
      }}
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'column',
        maxWidth: '500px',
        backgroundColor: 'white',
        minHeight: '95vh',
        borderRadius: '10px',
        position: 'relative',
        width: '100%',
        height: '100%',
        transition: 'transform 0.8s',
        transformStyle: 'preserve-3d',
        boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)',
        perspective: '1000px'
      }}
    >
      <div>{button}</div>

      <Box
        component='div'
        flexDirection='row'
        flexWrap='nowrap'
        alignItems='center'
        width='100%'
        borderRadius='5px'
        style={{
          backfaceVisibility: 'hidden',
          WebkitBackfaceVisibility: 'hidden'
        }}
        position='absolute'
        id='frontView'
      >
        {frontView}
      </Box>
      <Box
        component='div'
        flexDirection='row'
        flexWrap='nowrap'
        alignItems='center'
        width='100%'
        borderRadius='5px'
        style={{
          backfaceVisibility: 'hidden',
          WebkitBackfaceVisibility: 'hidden',
          transform: 'rotateY(180deg)'
        }}
        position='absolute'
        id='backView'
        height={'100%'}
      >
        {backView}
      </Box>
    </Box>
  )
}
